<template>
  <div v-if="pages && pages.length && !forceHideBreadCrumb">
    <b-collapse id="collapse-navbar" :visible="isBreadCrumb">
      <div class="mt-1 mx-3 shadow bg-white rounded border bread-crumb-style">
        <ul class="nav nav-pills nav-fill ul-style">
          <li
            class="nav-item link-style"
            v-for="(page, key) in pages"
            :key="key"
          >
            <span
              @click="goTo(page.path)"
              class="nav-link nav-style"
              :class="isMatchURL(page)"
            >
              <div class="nav-short-name">
                {{
                  page.meta.breadcrumbs.displayName ||
                    page.meta.navbar.displayName
                }}
              </div>
              <div class="nav-full-name">
                {{ page.meta.navbar.displayName }}
              </div>
            </span>
            <hr class="m-0" v-if="isMobile" />
            <div v-else class="vr" />
          </li>
        </ul>
      </div>
    </b-collapse>
    <div class="rounded-pill d-flex flex-row-reverse mr-2">
      <b-button
        class="mt-1 py-0 px-2 hide-button"
        @click="hideBreadCrumb"
        v-if="isMobile"
        variant="outline-primary"
      >
        <font-awesome-icon
          :icon="['fas', isBreadCrumb ? 'chevron-up' : 'chevron-down']"
          class="exitButton pb-1"
        />
      </b-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'

import { userMappers } from '@/store/modules/user'
import { RouteConfig } from 'vue-router/types/router'
import { routes } from '@/router'
import { mobileWidthMapper } from '@/store/modules/mobileWidth'
import { PermissionPageManager } from '@/api/permissions/pages'
import { permissions } from '@/api/permissions/permissions'
import ResolveCompanyId from '@/mixins/ResolveCompanyId'
import { routeBuild } from '@/utils/urls'

const Mappers = Vue.extend({
  computed: {
    ...mobileWidthMapper.mapGetters(['isMobile']),
    ...userMappers.mapGetters([
      'isAuthenticated',
      'isPartner',
      'userCompany',
      'isPRManager'
    ])
  }
})
@Component({ mixins: [ResolveCompanyId] })
export default class Breadcrumbs extends Mappers {
  private pages: RouteConfig[] = []

  getCompanyId!: Function
  companyIdToURL!: Function

  private forceHideBreadCrumb = false

  private isBreadCrumb = true

  private hideBreadCrumb() {
    this.isBreadCrumb = !this.isBreadCrumb
  }

  private isMatchURL(route: any) {
    return route.name === this.$route.name ? 'active' : ''
  }

  private goTo(path: string) {
    this.$router
      .push(
        routeBuild(path, {
          partnerId: this.companyIdToURL(this.getCompanyId())
        })
      )
      .catch(() => {
        return undefined
      })
  }

  @Watch('$route')
  private onRouteChange() {
    this.forceHideBreadCrumb =
      this.isPartner &&
      this.getCompanyId() !== this.userCompany.company.id &&
      !this.isPRManager

    const routerPages: RouteConfig[] | undefined = routes[0].children
    const ability = PermissionPageManager.pages()
    this.pages = (routerPages ?? []).filter(
      p =>
        this.$route.meta?.breadcrumbs?.isDisplay &&
        p?.meta?.breadcrumbs?.isDisplay &&
        ability.can(permissions.viewPage, p.name)
    )
  }

  private created() {
    this.onRouteChange()
  }
}
</script>

<style scoped>
.exitButton {
  font-size: 1.2em;
}
.vr {
  border-left: 1px solid #333;
  border-color: rgba(222, 226, 230);
  margin-left: 2px;
  margin-right: 2px;
}
.ul-style {
  display: flex;
}
.link-style {
  display: flex;
  flex: unset;
}
.nav-style {
  margin: 1px;
}
.nav-style:hover {
  cursor: pointer;
}

.hide-button {
  max-height: 17px;
}
.bread-crumb-style {
  display: flex;
  flex-direction: row;
}
.nav-short-name {
  display: block;
}
.nav-full-name {
  display: none;
}
@media screen and (max-width: 768px) {
  .ul-style,
  .link-style {
    display: block;
  }
  .bread-crumb-style {
    display: flex;
    flex-direction: column;
  }
  .nav-short-name {
    display: none;
  }
  .nav-full-name {
    display: block;
  }
}
</style>
